import { render } from "./cubeOne.vue?vue&type=template&id=460e2e62&lang=true"
import script from "./cubeOne.vue?vue&type=script&lang=js"
export * from "./cubeOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__